// extracted by mini-css-extract-plugin
module.exports = {"link":"link_link__db9uP","disabled":"link_disabled__M1LSi","external":"link_external__xWax3"};